import React from "react";
import Editor from "@app/components/report-document/editor";
import "../styles/docx-import-modal.scoped.scss";

const SectionDiffPreview = ({ oldSection, newSection }) => (
    <div className="section-preview">
        <div className="section-preview-view">
            <div className="section-preview-col">
                <b>Current</b>
                {oldSection ? (
                    <div className="section-block">
                        <div className="section-title">{oldSection.title}</div>
                        <Editor
                            contentClassName="section-preview-content"
                            value={oldSection.content}
                            readonly
                            onEditorReady={() => {}}
                            isPreviewMode={true}
                        />
                    </div>
                ) : (
                    <div className="no-section">No section</div>
                )}
            </div>
            <div className="section-preview-col">
                <b>Imported</b>
                <div className="section-block">
                    <Editor
                        contentClassName="section-preview-content"
                        value={newSection.content}
                        readonly
                        onEditorReady={() => {}}
                        isPreviewMode={true}
                    />
                </div>
            </div>
        </div>
    </div>
);

export default SectionDiffPreview;
